import { FILE_TYPE_LIMITS } from './constants';

const formatLimitLabelFromBytes = (maxBytes) => {
  if (maxBytes == null || Number.isNaN(maxBytes)) return '';
  const gb = 1024 ** 3;
  const mb = 1024 ** 2;
  if (maxBytes % gb === 0 && maxBytes >= gb) {
    return `${maxBytes / gb}GB`;
  }
  if (maxBytes % mb === 0) {
    return `${maxBytes / mb}MB`;
  }
  if (maxBytes >= gb) {
    return `${Math.round(maxBytes / gb)}GB`;
  }
  return `${Math.round(maxBytes / mb)}MB`;
};

export const getFileTypeLimitByName = (fileName) => {
  const dotIndex = (fileName || '').toLowerCase().lastIndexOf('.');
  if (dotIndex < 0) return null;
  const ext = fileName.toLowerCase().substring(dotIndex);
  return (
    Object.values(FILE_TYPE_LIMITS).find((cfg) =>
      cfg.extensions.includes(ext),
    ) || null
  );
};

export const validateEmail = (email) => {
  if (!email) return 'Email is required';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  return '';
};

export const validateRequired = (value, fieldName) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return `${fieldName} is required`;
  }
  return '';
};

export const validatePrice = (price) => {
  if (price === '' || price === null || price === undefined) {
    return 'Price is required';
  }
  const numPrice = parseFloat(price);
  if (isNaN(numPrice)) {
    return 'Price must be a valid number';
  }
  if (numPrice < 0) {
    return 'Price must be a positive number';
  }
  return '';
};

export const validateFileSize = (file, maxSizeOrConfig) => {
  if (!file) return '';
  const isConfigObj =
    maxSizeOrConfig != null &&
    typeof maxSizeOrConfig === 'object' &&
    'maxBytes' in maxSizeOrConfig;
  const maxBytes = isConfigObj
    ? maxSizeOrConfig.maxBytes
    : maxSizeOrConfig;
  const label = isConfigObj
    ? maxSizeOrConfig.label || formatLimitLabelFromBytes(maxBytes)
    : formatLimitLabelFromBytes(maxBytes);

  if (file.size > maxBytes) {
    return `File size must be less than ${label}`;
  }
  return '';
};

export const validateFileType = (file, allowedTypes) => {
  if (!file) return '';
  if (!allowedTypes.includes(file.type)) {
    return 'File type not supported';
  }
  return '';
};

export const validateFileExtension = (fileName, allowedExtensions) => {
  if (!fileName || !allowedExtensions?.length) return '';
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0) {
    return `File type not supported. Allowed types: ${allowedExtensions.join(', ')}`;
  }
  const ext = fileName.toLowerCase().substring(dotIndex);
  if (!allowedExtensions.includes(ext)) {
    return `File type not supported. Allowed types: ${allowedExtensions.join(', ')}`;
  }
  return '';
};

export const validateFileName = (fileName) => {
  if (!fileName) return '';
  const extension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
  if (['.dat', '.exe'].includes(extension)) {
    return '.dat and .exe files are not supported';
  }
  return '';
};

export const validateProductForm = (product, productType) => {
  const errors = {};
  
  errors.name = validateRequired(product.name, 'Product name');
  errors.description = validateRequired(product.description, 'Product description');
  errors.price = validatePrice(product.price);
  
  if (!product.imageUrl) {
    errors.imageUrl = 'Product image is required';
  }
  
  if (productType === 'digital' && !product.digitalFileUrl) {
    errors.digitalFileUrl = 'Digital file is required';
  }
  
  return errors;
};

export const validateBusinessInfo = (businessInfo) => {
  const errors = {};
  
  errors.companyName = validateRequired(businessInfo.companyName, 'Company name');
  errors.email = validateEmail(businessInfo.email);
  errors.address = validateRequired(businessInfo.address, 'Address');
  
  return errors;
};

export const hasValidationErrors = (errors) => {
  return Object.values(errors).some(error => error !== '');
};

